import React, { useState } from 'react'
import AccountAccessModalContent from './AccountAccessModalContent'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import { useAppSelector } from 'hooks/reduxHooks'

export interface AccountAccessModalResult {
  loggedIn?: boolean;
}

interface Props {
  initialMode?: App.UiAccountModalMode;
  resetPasswordToken?: string;
  hotelOfferDetails?: App.AccountModalOfferDetails;
}

function AccountAccessModal(props: Props) {
  const {
    initialMode = 'login',
    resetPasswordToken,
    hotelOfferDetails,
  } = props

  const [mode, setMode] = useState<App.UiAccountModalMode>(initialMode)
  const loading = useAppSelector(state => state.auth.processing)

  return (<ModalBase
    size="S"
  >
    <LoadingIndicator visible={loading} floating />
    <AccountAccessModalContent
      mode={mode}
      onModeChange={setMode}
      resetPasswordToken={resetPasswordToken}
      hotelOfferDetails={hotelOfferDetails}
    />
  </ModalBase>
  )
}

export default AccountAccessModal
